import { observer } from 'mobx-react';
import { useResolvedPath } from 'react-router-dom';
import { Loader } from '@servicetitan/web-components';
import { CenteredSpinner } from '@servicetitan/marketing-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { FieldsSettingsStore } from '../../stores/fields-settings.store';
import { CenteredError } from '../../../../../common/components/centered-error/centered-error';

export const FieldsSettingsPage = provide({ singletons: [FieldsSettingsStore] })(
    observer(() => {
        const [{ src }] = useDependencies(FieldsSettingsStore);

        const basename = useResolvedPath({
            pathname: '',
        }).pathname;

        return (
            <Loader
                src={src}
                basename={basename}
                errorFallback={<CenteredError />}
                loadingFallback={<CenteredSpinner />}
            />
        );
    }),
);
